<mat-sidenav-container class="login-main" *ngIf="!isLoading">
  <mat-sidenav-content>
    <div class="content" *ngIf="!isEmbed">
      <mat-card class="form-wrapper">
        <form
          class="form"
          [formGroup]="signinForm"
          (ngSubmit)="signinForm.valid && loginFn()"
          novalidate
        >
          <div class="header">
            <div class="logo"></div>
            <div class="title" *ngIf="dynamicBranding">
              {{ brandName }}
            </div>
            <div class="title" *ngIf="!dynamicBranding">
              {{ globals.TITLE }}
            </div>
          </div>
          <mat-progress-bar
            class="progress-bar"
            mode="indeterminate"
            *ngIf="isLoading"
          ></mat-progress-bar>
          <div class="main">
            <div class="signin">
              <div class="title">
                <h4
                  class="greeting"
                  i18n="greeting on signin|Greeting message on signin page@@greetingSignin"
                >
                  Welcome back!
                </h4>
                <span class="text">Please sign in</span>
              </div>
              <div class="credential-form">
                <div class="invalid-notification" *ngIf="errorMsg">
                  <mat-error
                    class="credentials"
                    [innerHtml]="errorMsg | domSanitizer: 'html'"
                  ></mat-error>
                </div>

                <div class="input-group">
                  <div class="label">User</div>
                  <input
                    autocomplete="off"
                    matInput
                    placeholder="Your username"
                    i18n-placeholder="@@usernamePlaceholderSignin"
                    formControlName="username"
                    required
                    type="text"
                    maxlength="254"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="off"
                    autofocus
                  />
                  <mat-error
                    *ngIf="
                      signinForm.get('username').invalid &&
                      (signinForm.get('username').dirty || signinForm.get('username').touched)
                    "
                    >{{ getErrorMessageUsername() }}</mat-error
                  >
                </div>

                <div class="input-group">
                  <div class="label">Password</div>
                  <div class="input-row">
                    <input
                      matInput
                      placeholder="Your password"
                      i18n-placeholder="@@passPlaceholderSignin"
                      formControlName="password"
                      required
                      [type]="hide ? 'password' : 'text'"
                      maxlength="254"
                    />
                    <mat-icon matSuffix (click)="hide = !hide">{{
                      hide ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
                  </div>
                  <mat-error
                    *ngIf="
                      signinForm.get('password').invalid &&
                      (signinForm.get('password').dirty || signinForm.get('password').touched)
                    "
                    >{{ getErrorMessagePassword() }}</mat-error
                  >
                </div>

                <button
                  mat-stroked-button
                  class="sign-in-btn"
                  type="submit"
                  [disabled]="!signinForm.valid || isLoading"
                  i18n="signin button|Signin button on signin page@@buttonSignin"
                >
                  SIGN IN
                </button>
                <div *ngIf="openIdItems.length > 0">
                  <div class="left-right-divider">
                    <p class="sign-in-form-divider-text">
                      OR
                    </p>
                  </div>
                  <div class="openID-button-container">
                    <button
                      *ngFor="let providers of openIdItems"
                      mat-stroked-button
                      (click)="onOpenIdLogin(providers)">
                      <i class="material-icons icon">vpn_key</i>
                      <span> SIGN IN WITH {{providers.name}} </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-card>
    </div>
    <div class="no-valid-message" *ngIf="isEmbed">
      <span class="mdi mdi-24px mdi-security"></span>
      <div *ngIf="!isTokenValid">You do not have access to view this page</div>
      <div *ngIf="!isValidPermission">You do not have permission to view this page</div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
